import { isAmazonHost, logger } from '../utils';
import { useHeap } from './useHeap';

export const useMetrics = () => {
  const { track: trackHeap } = useHeap();

  const track = (
    event: string,
    properties?: Record<string, unknown> | undefined
  ) => {
    if (isAmazonHost()) {
      logger.info(event, properties);
    } else {
      trackHeap(event, properties);
    }
  };

  return {
    track,
  };
};
